export default __webpack_public_path__ + "static/media/business-video.b0641da8.svg";